module.exports = __webpack_public_path__ + "img/logo_belgravia.43673b5d.png";